import React from 'react';
import { NavLink } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import { DRAWER_WIDTH } from './MainContainer';

const UniversalSidebar = ({ instashellSetup, mobileOpen, onClose, isMobile }) => {

    const generateSidebarItems = () => {
        const items = [];
        let inSection = false;

        instashellSetup.sidebarItemsArr.forEach((item, index) => {
            if (item.type === 'link') {
                if (!inSection) inSection = true;
                items.push(
                    <NavLink
                        key={index}
                        to={item.path}
                        className="sidebar-nav-link"
                        onClick={isMobile ? onClose : undefined}
                    >
                        <ListItem disableGutters sx={{ px: 1, py: 0.25 }}>
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{
                                    className: 'drawer-link-medium sidebar-font',
                                    sx: { lineHeight: 1.4 },
                                }}
                            />
                        </ListItem>
                    </NavLink>
                );
            } else if (item.type === 'break') {
                items.push(
                    <Divider
                        key={index}
                        sx={{ my: 1.5, borderColor: 'rgba(128,128,128,0.12)' }}
                    />
                );
                inSection = false;
            }
        });

        return items;
    };

    const drawerContent = (
        <div style={{ width: DRAWER_WIDTH, display: 'flex', flexDirection: 'column', height: '100%' }}>
            <div style={{ padding: '20px 16px 12px' }}>
                <div style={{ marginBottom: '4px' }}>
                    <span
                        className="sidebar-font"
                        style={{
                            fontFamily: instashellSetup?.sidebarHeader?.titleFont,
                            fontSize: instashellSetup?.sidebarHeader?.titleSize,
                            lineHeight: 1.1,
                            display: 'block',
                        }}
                    >
                        {instashellSetup?.sidebarHeader?.titleLabel}
                    </span>
                </div>
            </div>

            <Divider sx={{ borderColor: 'rgba(128,128,128,0.12)' }} />

            <List sx={{ flex: 1, px: 1, py: 1.5, overflowY: 'auto' }}>
                {generateSidebarItems()}
            </List>
        </div>
    );

    return (
        <Drawer
            variant={isMobile ? 'temporary' : 'permanent'}
            anchor="left"
            open={isMobile ? mobileOpen : true}
            onClose={isMobile ? onClose : undefined}
            ModalProps={{ keepMounted: true }}
            PaperProps={{
                style: {
                    backgroundColor: 'var(--glass-sidebar-bg)',
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    backgroundImage: 'none',
                    borderRight: '1px solid var(--glass-border)',
                },
            }}
            sx={{
                width: DRAWER_WIDTH,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: DRAWER_WIDTH,
                    boxSizing: 'border-box',
                },
            }}
        >
            {drawerContent}
        </Drawer>
    );
};

export default UniversalSidebar;
